import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Set the filter for all orders-related lists
 *
 * @private
 */
export const setOrdersFilter = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.ui.list.ListOptions,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('ui/listOptions/setOrdersFilter', async (options, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/ui/setOrdersFilter', {
      category: 'rpc',
      type: 'rpc/ui/setOrdersFilter',
      options,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {setOrdersFilter}`,
      { tags: ['rpc', 'ui', 'listOptions'], info: { options } },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Set orders filter completed`,
      error,
    })
  }
})
